// src/components/PostForm.js
import config from '../config';
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Stack,
  Switch,
  FormControlLabel,
  FormGroup,
  Checkbox
} from "@mui/material";

const PostFormArxiv = () => {
  const [formData, setFormData] = useState({
    query: "(('deep learning') OR ('machine learning')) AND ('antibody')",
    direction: "(('deep learning') OR ('machine learning')) AND ('antibody')",
    start_date: "2020-01-01",
    end_date: "2023-12-31",
    size: "10",
    customer_name: "machao",
    translate_to_cn: false,
    task_type: "arxiv",
    model_names: ["gpt-4o-mini"],
    do_compare: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle checkbox change for model_names
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setFormData((prevData) => {
      const newModelNames = checked
        ? [...prevData.model_names, name]  // Add the model if checked
        : prevData.model_names.filter((model) => model !== name);  // Remove the model if unchecked
      console.log(newModelNames);
      return { ...prevData, model_names: newModelNames };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Add validation for size and date fields if needed
    if (!/^\d{4}-\d{2}-\d{2}$/.test(formData.start_date) || !/^\d{4}-\d{2}-\d{2}$/.test(formData.end_date)) {
      alert("Please provide valid dates in the format yyyy-mm-dd.");
      return;
    }
    if (isNaN(formData.size) || formData.size <= 0) {
      alert("Size must be a positive integer.");
      return;
    }

    const requestBody = [
      {
        ...formData
      },
    ];
    
    try {
        const response = await fetch(`${config.apiUrl}/pipelines`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (response.ok) {
          const data = await response.json();
          console.log('Success:', data);
          alert('Form submitted successfully!');
        } else {
          console.error('Error:', response.statusText);
          alert(`Error: ${response.statusText}`);
        }
      } catch (error) {
        console.error('Network Error:', error);
        alert('Network Error: Failed to submit the form.');
    };

    console.log("Form Submitted:", formData);
    // Reset the form after submission
    setFormData({
      query: "(('deep learning') OR ('machine learning')) AND ('antibody')",
      direction: "(('deep learning') OR ('machine learning')) AND ('antibody')",
      start_date: "2020-01-01",
      end_date: "2023-12-31",
      size: "10",
      customer_name: "machao",
      translate_to_cn: false,
      task_type: "arxiv",
      do_compare: false,
      model_names: ["gpt-4o-mini"]
    });
  };

  return (
    <Container maxWidth="md">
      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: "white",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Post Form
        </Typography>

        <Stack spacing={3}>
          <TextField
            label="Query"
            name="query"
            value={formData.query}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Direction"
            name="direction"
            value={formData.direction}
            onChange={handleChange}
            fullWidth
            placeholder="Optional"
          />

          <TextField
            label="Start Date"
            name="start_date"
            value={formData.start_date}
            onChange={handleChange}
            fullWidth
            required
            placeholder="yyyy-mm-dd"
          />

          <TextField
            label="End Date"
            name="end_date"
            value={formData.end_date}
            onChange={handleChange}
            fullWidth
            required
            placeholder="yyyy-mm-dd"
          />

          <TextField
            label="Size"
            name="size"
            value={formData.size}
            onChange={handleChange}
            fullWidth
            required
            type="number"
          />

          <TextField
            label="Customer Name"
            name="customer_name"
            value={formData.customer_name}
            onChange={handleChange}
            fullWidth
            required
          />

          <FormControlLabel
            control={
              <Switch
                name="translate_to_cn"
                checked={formData.translate_to_cn}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Translate to Chinese"
          />

          <FormControlLabel
            control={
              <Switch
                name="do_compare"
                checked={formData.do_compare}
                onChange={handleChange}
                color="primary"
              />
            }
            label="Compare Between Models"
          />

          <FormGroup>
            <Typography variant="h6" gutterBottom>
              Select Models
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  name="gpt-4o-mini"
                  checked={formData.model_names.includes("gpt-4o-mini")}
                  onChange={handleCheckboxChange}
                />
              }
              label="gpt-4o-mini"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="glm-4"
                  checked={formData.model_names.includes("glm-4")}
                  onChange={handleCheckboxChange}
                />
              }
              label="glm-4"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="glm-4-plus"
                  checked={formData.model_names.includes("glm-4-plus")}
                  onChange={handleCheckboxChange}
                />
              }
              label="glm-4-plus"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="deepseek-chat"
                  checked={formData.model_names.includes("deepseek-chat")}
                  onChange={handleCheckboxChange}
                />
              }
              label="deepseek-chat"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="deepseek-v3-250324"
                  checked={formData.model_names.includes("deepseek-v3-250324")}
                  onChange={handleCheckboxChange}
                />
              }
              label="deepseek-v3-250324"
            />
          </FormGroup>

          <Button type="submit" variant="contained" color="primary" fullWidth>
            Submit
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default PostFormArxiv;
